module.exports = __webpack_public_path__ + "img/blockS3-card3.82dcb86f.jpg";